/**
 * 首页相关接口
 */

import { post, ApiResponse } from './api';
import { API_PATHS } from './apiPaths';

/**
 * 获取首页数据
 */
export async function getHomePage(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.GetHomePage, body, { params });
}
